import React, { useEffect, useState } from "react"
import CurrencyFormat from "react-currency-format"
import Styles from './styles.module.sass'

const ContPlanCardPay = (props) => {

    const {
        ind,
        plan_name,
        monthly_payment,
        balance_cutting,
        new_balance_cutting,
        minimum_payment,
        pay_plan,
        sequence,
        showInfoPlan,
        allChecked
    } = props

    const [valuePlan, setValuePlan] = useState(monthly_payment)
    const [isDisabled, setIsDisabled] = useState(true)

    const changeValuePlan = (event) =>{
        let pricePlan = event.target.value
        let totalFloat
        let regE = /[^\d\.\d+]+/g
        let precioRedondo = pricePlan.replace(regE,'')
        if( isNaN(precioRedondo) ){
            totalFloat = parseFloat(precioRedondo)
        }else{
            totalFloat = precioRedondo
        }
        setValuePlan( totalFloat ) 
    }

    const [resetPay, setResetPay] = useState(false)
    useEffect(()=>{
        if(allChecked){
            setIsDisabled(false)
        }else{
            setResetPay(true)
            setIsDisabled(true)
        }
    },[allChecked])
    
    useEffect(()=>{
        if(resetPay){
            setValuePlan(monthly_payment)
            setResetPay(false)
        }
    },[resetPay])

    const validateCheck = (event) => {
        let valid = event.target.checked
        if(valid){
            setIsDisabled(false)
        }
        else{
            setResetPay(true)
            setIsDisabled(true)
        }
    }

    return(
        <div className={`${Styles?.cardPay} cardPay`}>
            <div className={`${Styles?.cardPaySup} cardPaySup`}>
                <div className={Styles?.contentPaySup}>
                    <label className={`${Styles?.topPlanName} topPlanName`} for={`cardPaysegment_${ind}`}>
                        <input
                            type="checkbox"
                            name={plan_name}
                            value={valuePlan}
                            id={`cardPaysegment_${ind}`}
                            onChange={validateCheck}
                            data-sequence={sequence}
                            data-plan={pay_plan}
                        />
                        <p>{plan_name}</p>
                    </label>
                    <input type="text" value={valuePlan} onChange={changeValuePlan} className={`${Styles?.inputLine} inputLine`} disabled={isDisabled}/>
                </div>
                <div className={Styles?.showCardInf} onClick={(inedex) => showInfoPlan(ind)} ></div>
            </div>
            <div className={`${Styles?.cardPayInf} cardPayInf`}>
                <div className={Styles?.contInfoPayData}>
                    <p>Saldo actual</p>
                    <CurrencyFormat
                        value={Number(new_balance_cutting % 1) === 0 ? new_balance_cutting + '.001' : new_balance_cutting}
                        displayType={'text'}
                        decimalScale={2}
                        FixedDecimalScale={true}
                        thousandSeparator={true} prefix={'$'} renderText={value => <strong>{value} </strong>}
                    />
                </div>
                <div className={Styles?.contInfoPayData}>
                    <p>Saldo facturado</p>
                    <CurrencyFormat
                        value={Number(balance_cutting % 1) === 0 ? balance_cutting + '.001' : balance_cutting}
                        displayType={'text'}
                        decimalScale={2}
                        FixedDecimalScale={true}
                        thousandSeparator={true} prefix={'$'} renderText={value => <strong>{value} </strong>}
                    />
                </div>
                <div className={Styles?.contInfoPayData}>
                    <p>Pago minimo</p>
                    <CurrencyFormat
                        value={Number(minimum_payment % 1) === 0 ? minimum_payment + '.001' : minimum_payment}
                        displayType={'text'}
                        decimalScale={2}
                        FixedDecimalScale={true}
                        thousandSeparator={true} prefix={'$'} renderText={value => <strong>{value} </strong>}
                    />
                </div>
            </div>
        </div>

    )
}

export default ContPlanCardPay;